export default __webpack_public_path__ + "static/samf-logo-min-43d60d7ccd7b4cf8b64fff31fe4d72d8.svg";